import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { createStore } from 'redux';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import App from './App';

//Devtools for viewing state changes in browser
const store = createStore(rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          {/* /dev = developer portfolio, /designer = designer portfolio.
              One route + param keeps a single App instance, so toggling
              between the two doesn't remount the whole page. */}
          <Route path="/:mode" element={<App />} />
          {/* default ("/") opens the developer portfolio */}
          <Route path="*" element={<Navigate to="/dev" replace />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);